import { Link } from "react-router-dom";
import { useSEO } from "@/lib/seo";
import PageHeader from "@/components/sections/PageHeader";
import { ABOUT, IMAGES } from "@/lib/site";
import { GraduationCap, MapPin, Stethoscope, Award } from "lucide-react";
import FinalCTA from "@/components/sections/FinalCTA";

export default function AboutPage() {
  useSEO({
    title: "About Dr. Anusha Mandava",
    description:
      "Dr. Anusha Mandava is a Radiation Oncologist in Hyderabad with 10 years of clinical experience, trained at Kidwai Memorial Institute of Oncology and HCG Bangalore.",
    keywords:
      "Dr Anusha Mandava, Radiation Oncologist Hyderabad, Cancer Specialist Hyderabad",
    path: "/about",
  });

  return (
    <div data-testid="about-page">
      <PageHeader
        eyebrow="About Dr. Anusha"
        title="Radiation oncology, practiced with clarity and care."
        description={ABOUT.short}
      />

      <section className="py-20 md:py-28">
        <div className="max-w-7xl mx-auto px-6 md:px-10 grid grid-cols-1 lg:grid-cols-12 gap-12 items-start">
          <div className="lg:col-span-5">
            <div className="rounded-3xl overflow-hidden border border-slate-100 aspect-[4/5]">
              <img
                src={IMAGES.aboutDoctor}
                alt="Dr. Anusha Mandava, Radiation Oncologist in Hyderabad"
                className="w-full h-full object-cover"
              />
            </div>
          </div>
          <div className="lg:col-span-7">
            <div className="space-y-5 text-slate-600 leading-relaxed">
              {ABOUT.long.map((p, i) => (
                <p key={i}>{p}</p>
              ))}
            </div>

            <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 gap-4">
              {ABOUT.profile.map((item, i) => (
                <div
                  key={i}
                  className="rounded-2xl border border-slate-100 bg-slate-50 p-5"
                >
                  <div className="text-[10px] uppercase tracking-[0.18em] text-blue-700 font-semibold">
                    {item.label}
                  </div>
                  <div className="mt-2 font-serif text-lg text-slate-900 leading-snug">
                    {item.value}
                  </div>
                </div>
              ))}
            </div>

            <div className="mt-10 flex flex-col sm:flex-row gap-3">
              <Link
                to="/contact"
                className="inline-flex items-center justify-center gap-2 bg-blue-900 text-white font-semibold px-6 py-3.5 rounded-full hover:bg-blue-800"
              >
                Book a Consultation
              </Link>
              <Link
                to="/expertise"
                className="inline-flex items-center justify-center gap-2 border border-slate-200 text-slate-800 font-semibold px-6 py-3.5 rounded-full hover:bg-slate-50"
              >
                View Areas of Expertise
              </Link>
            </div>
          </div>
        </div>
      </section>

      <section className="py-16 bg-slate-50">
        <div className="max-w-7xl mx-auto px-6 md:px-10">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-6">
            {[
              { icon: Stethoscope, label: "10 Years", sub: "Clinical experience" },
              { icon: GraduationCap, label: "MBBS", sub: "Sri Devraj Urs Medical College" },
              { icon: Award, label: "Postgraduate", sub: "Kidwai Institute · HCG Bangalore" },
              { icon: MapPin, label: "Hyderabad", sub: "Practicing across leading centres" },
            ].map((c, i) => (
              <div key={i} className="bg-white rounded-2xl border border-slate-100 p-6">
                <div className="h-11 w-11 rounded-xl bg-blue-50 text-blue-800 flex items-center justify-center">
                  <c.icon className="h-5 w-5" />
                </div>
                <div className="mt-4 font-serif text-xl text-slate-900">
                  {c.label}
                </div>
                <div className="text-sm text-slate-500 mt-1">{c.sub}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <FinalCTA />
    </div>
  );
}
